(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const schemata = require('schemata')
const validateIfSet = require('@clocklimited/validity-validate-if-set')
const required = require('@clocklimited/validity-required')
const email = require('@clocklimited/validity-email')

module.exports = function () {
  return schemata(
    { _id:
      { type: String
      // @todo: once schemata can handle defaultValues in nested collections, add defaultValue here and remove it from
      // the service
      }
    , name:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , addressLine1:
      { type: String
      }
    , addressLine2:
      { type: String
      }
    , postcode:
      { type: String
      }
    , city:
      { type: String
      }
    , country:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , phone1:
      { type: String
      }
    , phone2:
      { type: String
      }
    , fax:
      { type: String
      }
    , email1:
      { type: String
      , validators:
        { all: [ email ]
        }
      }
    , email2:
      { type: String
      , validators:
        { all: [ validateIfSet(email) ]
        }
      }
    , info:
      { type: String
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/artist/company-schema.js","/components/service/artist")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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